import { defineStore } from 'pinia';
import { fetchWrapper } from '@/helpers';

export const useUserStore = defineStore({
  id: 'user',
  state: () => ({
    loader: {},
    logoutUrl: '',
    paymentUrl: '',
    course: {
      courseName: null,
      courseNumber: null,
      firstName: null,
      lastName: null,
      professorFullName: null,
    },
    shoppingCart: {
      sortedShoppingCart: [] as any,
      onHoldItems: [] as any,
      unpaidItems: [] as any,
      paidItems: [] as any,
    },
    shoppingCartInbox: {
      logo: null,
      hasAccess: false,
      loginUrl: '',
      sortedShoppingCart: [] as any,
      onHoldItems: [] as any,
      unpaidItems: [] as any,
      paidItems: [] as any,
    },
    capsimChallenge: {
      showLink: false,
      registrationLink: '',
      localStartDateTime: null,
      localEndDateTime: null,
      timezone: null,
    },
  }),
  actions: {
    async initStudent() {
      this.loader = { loading: true };
      await fetchWrapper
        .get('/studentapp/api/student-init')
        .then((data) => this.$patch(data))
        .catch((error) => (this.loader = { error }));
    },
    async initShoppingCart() {
      this.loader = { loading: true };
      await fetchWrapper
        .get('/studentapp/api/shopping-cart')
        .then((shoppingCart) => (this.shoppingCart = shoppingCart))
        .catch((error) => (this.loader = { error }));
      await fetchWrapper
        .get('/studentapp/api/shopping-cart-inbox')
        .then((shoppingCart) => {
          this.shoppingCartInbox = shoppingCart;
          if (this.shoppingCartInbox.sortedShoppingCart.length > 0) {
            this.shoppingCartInbox.logo = this.shoppingCartInbox.sortedShoppingCart[0];
            this.shoppingCartInbox.hasAccess = this.shoppingCartInbox.sortedShoppingCart.some(
              (shoppingCart: any) => shoppingCart.hasAccess
            );
            this.shoppingCartInbox.loginUrl = this.shoppingCartInbox.sortedShoppingCart[0].loginUrl;
          }
        })
        .catch((error) => (this.loader = { error }));
    },
    async initCapsimChallenge() {
      this.loader = { loading: true };
      await fetchWrapper
        .get('/studentapp/api/capsim-challenge')
        .then((capsimChallenge) => (this.capsimChallenge = capsimChallenge))
        .catch((error) => (this.loader = { error }));
    },
  },
});
